import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { hashHistory, withRouter } from 'react-router';

import headerActions from './../../reusable/Header/Header.actions';
import ProgressNavigationSteps from './../../reusable/ProgressNavigationSteps/ProgressNavigationSteps';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions.js';
import createAlertApi from './CreateAlertPage.api.js';

import StepOne from './CreateAlert.StepOne';
import StepTwo from './CreateAlert.StepTwo';

import {
    POPUP_LIFETIME,
    EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK,
    EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK
} from "./../../../scripts/constants.js";

class CreateAlertPage extends Component {

    static propTypes = {
        subHeaderMessage: PropTypes.string,
        data: PropTypes.object
    };

    static defaultProps = {
        subHeaderMessage: 'createNewAlert',
        data: {
            alertId: null,
            active: true,
            name: '',
            isNewsAlertsActive: true,
            isSwActive: true,
            isExperianActive: true,
            experianRiskAngles: {
                stabilityRisk:             EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK,
                delinquencyRisk:           EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK
            },
            thirdParty: {
                categoryNames: {},
                selectedCategories: [],
                selectedThirdPartiesIds: [],
                thirdPartySelection: 'all-third-parties-section',
                urlParams: {
                    categoryIdFilter: null,
                    direction: 'asc',
                    sortBy: 'companyTitleSort'
                }
            },
            riskAngles: {
                political: 3,
                economic: 3,
                social: 3,
                technological: 3,
                legal: 3,
                environmental: 3
            },
            emails: '',
            frequency: 'HOURLY',
            sendAs: 'INLINE',
            format: 'PDF'
        }
    };

    constructor(props) {
        super(props);

        this.state = {
            isCreateAlertOnStepOne: true,
            isCreateAlertSaving: false,
            data: this.props.data
        };

        this.goBack = this.goBack.bind(this);
        this.goToStepTwo = this.goToStepTwo.bind(this);
        this.resetCreateAlertToStepOne = this.resetCreateAlertToStepOne.bind(this);

        this.saveData = this.saveData.bind(this);
        this.toggleIsCreateAlertSaving = this.toggleIsCreateAlertSaving.bind(this);
        this.createAlert = this.createAlert.bind(this);
        this.updateAlert = this.updateAlert.bind(this);
        this.showSuccessPopup = this.showSuccessPopup.bind(this);
        this.showFailurePopup = this.showFailurePopup.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader(this.props.subHeaderMessage);
    }


    //continues to Step2
    goToStepTwo() {
        this.setState({
            isCreateAlertOnStepOne: false
        })
    }

    // used when the Previous button is clicked, to go back to step1
    resetCreateAlertToStepOne() {
        this.setState({
            isCreateAlertOnStepOne: true
        })
    }

    // used when pressing Cancel on Step1 and Step2
    goBack() {
        hashHistory.push('/email-alerts');
    }

    //saves the data incoming from the components into the local state
    saveData(data) {
        let newData = {...this.state.data, ...data};
        this.setState({data: newData})
    }

    toggleIsCreateAlertSaving(isCreateAlertSaving) {
        this.setState({isCreateAlertSaving: isCreateAlertSaving})
    }

    //makes call to BE with the local state to create a new alert
    createAlert() {
        this.toggleIsCreateAlertSaving(true);
        let isNewAlert = true;
        createAlertApi.saveAlert(this.state.data, null, isNewAlert)
            .then((response) => {
                this.showSuccessPopup('Alerts_Create_UIText_steps.creationSuccess');
                this.props.router.push('/email-alerts');
            }).catch((error) => {
            this.showFailurePopup('General_CoreFunctionality_Error_general.saveError');
            this.toggleIsCreateAlertSaving(false);
            console.log("********************** Alert Creation Failed ********************");
        });

    }

    //makes call to BE with the local state to update the existing alert
    updateAlert() {
        this.toggleIsCreateAlertSaving(true);
        let isNewAlert = false;
        createAlertApi.saveAlert(this.state.data, this.props.data.alertId, isNewAlert)
            .then((response) => {
                this.showSuccessPopup('Alerts_Create_UIText_steps.updateSuccess');
                this.props.router.push('/email-alerts');
            }).catch((error) => {
            this.showFailurePopup('General_CoreFunctionality_Error_general.saveError');
            this.toggleIsCreateAlertSaving(false);
            console.log("********************** Edit Alert Update Failed ********************");
        });
    }

    showSuccessPopup(messageId) {
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: messageId,
                    values: {alertName: this.state.data.name},
                    messageType: 'success'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    showFailurePopup(messageId) {
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: messageId,
                    messageType: 'system-error'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    render() {

        return (
            <div className="create-alert-page">

                <ProgressNavigationSteps
                    formattedMessagesIds={['Alerts_Create_UIText_steps.step1', 'Alerts_Create_UIText_steps.step2']}
                    activeStep={this.state.isCreateAlertOnStepOne ? 0 : 1} />

                <div className={!this.state.isCreateAlertOnStepOne ? 'hidden' : 'visible'}>
                    <StepOne continue={this.goToStepTwo}
                             cancel={this.goBack}
                             data={this.state.data}
                             saveData={this.saveData}
                    />
                </div>

                <div className={this.state.isCreateAlertOnStepOne ? 'hidden' : 'visible'}>
                    <StepTwo resetCreateAlertToStepOne={this.resetCreateAlertToStepOne}
                             cancel={this.goBack}
                             data={this.state.data}
                             isCreateAlertSaving={this.state.isCreateAlertSaving}
                             saveData={this.saveData}
                             saveAlert={this.props.subHeaderMessage === 'createNewAlert' ?
                                 this.createAlert : this.updateAlert}
                    />
                </div>

            </div>
        )
    }

}

export default withRouter(CreateAlertPage);


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/CreateAlertPage.jsx